import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/asset/$chainId/$tokenAddress")({
  head: () => ({
    meta: [{ content: "noindex", name: "robots" }],
  }),
  loader: ({ context, params }) => {
    void import("~/features/asset/asset-route").then(
      ({ preloadAssetRoute }) => {
        void preloadAssetRoute(context, params);
      },
    );
  },
});
